import { ResolverContext } from '../types';
import {
  prepareDataForApolloCache,
  QueryInfo,
} from '../prepareDataForApolloCache';
import { trelloFetch } from '@trello/fetch';
import { QueryNotificationsCountArgs } from '../generated';
import { parseNetworkError } from '@trello/graphql-error-handling';

export const notificationsCountResolver = async (
  _parent: unknown,
  args: QueryNotificationsCountArgs | null,
  context: ResolverContext,
  info: QueryInfo,
) => {
  const { grouped, filter } = args || {};
  const apiUrl = '/1/members/me/notificationsCount';
  const params = new URLSearchParams();

  if (grouped) {
    params.set('grouped', grouped.toString());
  }

  if (filter) {
    params.set('filter', filter);
  }

  const queryString = `${params}`;

  const response = await trelloFetch(
    queryString.length ? `${apiUrl}?${queryString}` : apiUrl,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
    {
      networkRequestEventAttributes: {
        source: 'graphql',
        resolver: 'notificationsCount',
        operationName: context.operationName,
      },
    },
  );

  if (!response.ok) {
    throw await parseNetworkError(response);
  }

  const notificationsCount = await response.json();

  return prepareDataForApolloCache(notificationsCount, info);
};

export const notificationsResolver = async (
  _parent: unknown,
  args: null,
  context: ResolverContext,
  info: QueryInfo,
) => {
  const apiUrl = '/1/members/me/notifications';
  const response = await trelloFetch(
    apiUrl,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
    {
      networkRequestEventAttributes: {
        source: 'graphql',
        resolver: 'notifications',
        operationName: context.operationName,
      },
    },
  );

  if (!response.ok) {
    throw await parseNetworkError(response);
  }

  const notifications = await response.json();

  return prepareDataForApolloCache(notifications, info);
};

export const notificationGroupsResolver = async (
  _parent: unknown,
  args: null,
  context: ResolverContext,
  info: QueryInfo,
) => {
  const apiUrl = '/1/members/me/notificationGroups';
  const response = await trelloFetch(
    apiUrl,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
    {
      networkRequestEventAttributes: {
        source: 'graphql',
        resolver: 'notificationGroups',
        operationName: context.operationName,
      },
    },
  );

  if (!response.ok) {
    throw await parseNetworkError(response);
  }

  const notificationGroups = await response.json();

  return prepareDataForApolloCache(notificationGroups, info);
};
